import { render, staticRenderFns } from "./CreditNotes.vue?vue&type=template&id=327584a5&scoped=true"
import script from "./CreditNotes.vue?vue&type=script&lang=ts"
export * from "./CreditNotes.vue?vue&type=script&lang=ts"
import style0 from "./CreditNotes.vue?vue&type=style&index=0&id=327584a5&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "327584a5",
  null
  
)

export default component.exports